<template>
  <div class="buscador-container">
    <div class="form-group">
      <label for="busqueda">🔍 Buscar Requerimiento:</label>
      <div class="input-container">
        <input 
          id="busqueda"
          v-model="busquedaRequerimiento"
          type="text" 
          placeholder="Requerimiento"
          class="form-control search-input"
          @input="filtrarRequerimientos"
          @focus="mostrarLista = true"
          @blur="ocultarLista"
        >
        <div 
          v-if="mostrarLista && (requerimientosFiltrados.length > 0 || mostrarTodosRequerimientos || busquedaRequerimiento)"
          class="lista-requerimientos-dropdown"
          @mousedown.prevent
        >
          <div class="dropdown-header">
            <span v-if="busquedaRequerimiento">
              📋 Resultados encontrados ({{ requerimientosFiltrados.length }})
            </span>
            <span v-else>
              📋 Todos los requerimientos ({{ totalRequerimientos }})
            </span>
          </div>
          <div class="lista-requerimientos">
            <div 
              v-for="req in listaMostrar" 
              :key="(req.idEmpresa || req.nombreEmpresa) + '-' + req.cc_id_requerimientos"
              @click="seleccionarRequerimiento(req)"
              class="requerimiento-item"
              :class="{ 'selected': requerimientoSeleccionado === ((req.idEmpresa || req.nombreEmpresa) + '-' + req.cc_id_requerimientos) }"
            >
              <div class="req-titulo">{{ req.cc_nombre_requerimiento }}</div>
              <div class="req-area">
                <span class="req-empresa" :class="req.nombreEmpresa === 'Facilisimo' ? 'empresa-facilisimo' : 'empresa-apostar'">
                  {{ req.nombreEmpresa || 'Apostar' }}
                </span>
                • {{ req.cc_nombre_area }} • ID: {{ req.cc_id_requerimientos }}
              </div>
            </div>
          </div>
          <div v-if="!busquedaRequerimiento && listaMostrar.length > 50" class="mas-resultados">
            💡 Tip: Escribe algo para filtrar y encontrar más rápido lo que buscas
          </div>
        </div>
      </div>
      <small style="color: #6c757d; font-size: 0.8rem;">
        💡 Escribe cualquier palabra clave para filtrar los {{ totalRequerimientos }} requerimientos
      </small>
    </div>
    
    <!-- Mensaje si no hay resultados -->
    <div v-if="busquedaRequerimiento && requerimientosFiltrados.length === 0 && mostrarLista && busquedaRequerimiento.trim()" class="alert" style="background: #fff3cd; color: #856404; border: 1px solid #ffeaa7;">
      <strong>🔍 Sin resultados</strong><br>
      No se encontraron requerimientos que coincidan con "<strong>{{ busquedaRequerimiento }}</strong>".<br>
      <small>Intenta con otras palabras como: "giros", "acciones", "nova", "betplay", "facilisimo", "apostar", etc.</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuscadorRequerimientos',
  props: {
    requerimientos: {
      type: Array,
      default: () => []
    },
    requerimientoSeleccionado: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      busquedaRequerimiento: '',
      requerimientosFiltrados: [],
      mostrarLista: false,
      mostrarTodosRequerimientos: false
    }
  },
  computed: {
    totalRequerimientos() {
      return this.requerimientos.length
    },
    listaMostrar() {
      if (this.busquedaRequerimiento) {
        return this.requerimientosFiltrados
      } else if (this.mostrarTodosRequerimientos) {
        return this.requerimientos
      }
      return []
    }
  },
  methods: {
    filtrarRequerimientos() {
      // 🆕 Mostrar lista cuando hay búsqueda
      if (this.busquedaRequerimiento) {
        this.mostrarLista = true
        this.mostrarTodosRequerimientos = false
      } else {
        this.requerimientosFiltrados = []
        if (this.mostrarLista) {
          this.mostrarTodosRequerimientos = true
        }
        return
      }
      
      const busqueda = this.busquedaRequerimiento.toLowerCase().trim()
      this.requerimientosFiltrados = this.requerimientos.filter(req => {
        const nombreEmpresa = (req.nombreEmpresa || '').toLowerCase()
        const nombreRequerimiento = (req.cc_nombre_requerimiento || '').toLowerCase()
        const nombreArea = (req.cc_nombre_area || '').toLowerCase()
        const idRequerimiento = (req.cc_id_requerimientos || '').toString()
        
        return nombreRequerimiento.includes(busqueda) ||
               nombreArea.includes(busqueda) ||
               nombreEmpresa.includes(busqueda) ||
               idRequerimiento.includes(busqueda)
      })
    },
    
    seleccionarRequerimiento(requerimiento) {
      // 🆕 Prevenir que el blur cierre la lista antes del click
      this.mostrarLista = false
      this.busquedaRequerimiento = ''
      this.requerimientosFiltrados = []
      this.mostrarTodosRequerimientos = false
      this.$emit('requerimiento-seleccionado', requerimiento)
    },
    
    ocultarLista() {
      // 🆕 Delay aumentado para permitir el click en los items
      setTimeout(() => {
        this.mostrarLista = false
        this.mostrarTodosRequerimientos = false
      }, 300)
    },
    
    limpiarBusqueda() {
      this.busquedaRequerimiento = ''
      this.requerimientosFiltrados = []
      this.mostrarLista = false
      this.mostrarTodosRequerimientos = false
    }
  }
}
</script>

<style scoped>
.buscador-container {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  border-radius: 16px;
  border: 1px solid rgba(41, 70, 151, 0.1);
  box-shadow: 0 4px 12px rgba(41, 70, 151, 0.08);
}

.form-group {
  margin-bottom: 1.5rem;
  position: relative;
}

.input-container {
  position: relative;
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 700;
  color: #294697;
  font-size: 1.1rem;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
}

.search-input {
  font-size: 1rem;
  padding: 1rem 1.25rem;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}

.search-input:focus {
  border-color: #294697;
  box-shadow: 
    0 0 0 4px rgba(41, 70, 151, 0.1),
    inset 0 2px 4px rgba(0,0,0,0.05);
  outline: none;
  background: #ffffff;
  transform: translateY(-1px);
}

.search-input::placeholder {
  color: #adb5bd;
  font-style: italic;
}

.lista-requerimientos-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 4px;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border: 1px solid rgba(41, 70, 151, 0.15);
  border-radius: 12px;
  box-shadow: 
    0 12px 24px rgba(41, 70, 151, 0.15),
    0 4px 8px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.2s ease-out;
  overflow: hidden;
  /* Evita scroll horizontal del contenedor */
  overflow-x: hidden;
}

.dropdown-header {
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #294697, #007bff);
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mas-resultados {
  text-align: center;
  padding: 0.75rem;
  color: #6c757d;
  font-size: 0.85rem;
  background: rgba(41, 70, 151, 0.05);
  border-top: 1px solid rgba(41, 70, 151, 0.1);
}

.form-group small {
  display: block;
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: linear-gradient(135deg, #e8f4fd, #d1ecf1);
  border-radius: 8px;
  border-left: 3px solid #007bff;
  font-size: 0.85rem;
  color: #0c5460;
}

.requerimientos-filtrados {
  margin-top: 1.5rem;
  animation: slideDown 0.3s ease-out;
}

.requerimientos-filtrados h4 {
  background: linear-gradient(135deg, #294697, #007bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
  margin-bottom: 1rem;
}

.lista-requerimientos {
  max-height: 350px;
  overflow-y: auto;
  /* Evita scroll horizontal de la lista */
  overflow-x: hidden;
  border: none;
  background: transparent;
  padding-bottom: 0.5rem;
}

.requerimiento-item {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(41, 70, 151, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: transparent;
}

.requerimiento-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  background: linear-gradient(135deg, #294697, #007bff);
  transition: width 0.3s ease;
}

.requerimiento-item:hover {
  background: linear-gradient(135deg, #e8f4fd, #d1ecf1);
  transform: translateX(2px);
}

.requerimiento-item:hover::before {
  width: 3px;
}

.requerimiento-item.selected {
  background: linear-gradient(135deg, #e8f4fd, #d1ecf1);
  border-left: 3px solid #294697;
}

.requerimiento-item:last-child {
  border-bottom: none;
  border-radius: 0 0 12px 12px;
  margin-bottom: 0;
  padding-bottom: 0.75rem;
}

.requerimiento-item:first-child {
  border-radius: 12px 12px 0 0;
}

.req-titulo {
  font-weight: 700;
  color: #294697;
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.req-area {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}

.req-empresa {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 700;
  font-size: 0.85rem;
  margin-right: 0.5rem;
}

.empresa-facilisimo {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.empresa-apostar {
  background: linear-gradient(135deg, #4ecdc4, #44a08d);
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.alert {
  padding: 1.25rem;
  border-radius: 12px;
  margin-bottom: 1rem;
  border: none;
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border-left: 4px solid #ffc107;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.15);
}

.alert strong {
  color: #856404;
  font-weight: 700;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .buscador-container {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .lista-requerimientos {
    max-height: 300px;
  }
  
  .requerimiento-item {
    padding: 0.625rem 0.875rem;
  }
  
  .search-input {
    padding: 0.875rem 1rem;
  }
  
  .lista-requerimientos-dropdown {
    margin-top: 2px;
    border-radius: 8px;
  }
  
  .dropdown-header {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
}
</style>
